import React from 'react';
import { 
  Box, 
  CircularProgress, 
  Typography, 
  Backdrop 
} from '@mui/material';

const Loading = ({ 
  open = true, 
  message = 'Loading...', 
  backdrop = true 
}) => {
  const content = (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={backdrop ? '100vh' : '200px'}
      sx={{
        ...(backdrop && {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          zIndex: 9999
        })
      }}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography 
        variant="h6" 
        sx={{ mt: 2, color: 'text.secondary' }}
      >
        {message}
      </Typography>
    </Box>
  );

  if (backdrop) {
    return (
      <Backdrop
        sx={{ 
          color: '#fff', 
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(255, 255, 255, 0.8)'
        }}
        open={open}
      >
        {content}
      </Backdrop>
    );
  }

  return content;
};

export default Loading; 